import { THackleSignUpEventKeys } from "types/hackle";
import { TTerms } from "types/terms/termsTypes";

export const TERMS_TYPE: { [key in TTerms]: TTerms } = {
  JOIN: "JOIN",
  PRIVACY_USE_AGREEMENT: "PRIVACY_USE_AGREEMENT",
  PRIVACY_POLICY: "PRIVACY_POLICY",
  EPC_CONTRACT: "EPC_CONTRACT",
  EPC_POLICY: "EPC_POLICY",
  OWNER_CONTRACT: "OWNER_CONTRACT",
  NONE: "NONE",
};

export const convertSignUpInputNameToHackleKey = (
  type:
    | "email"
    | "phoneNumber"
    | "password"
    | "re_password"
    | "name"
    | "managerPhoneNumber"
    | "businessLicenseNumber"
    | "companyName"
    | "managerName"
): THackleSignUpEventKeys => {
  switch (type) {
    case "email":
      return "blur_signUp_email";
    case "phoneNumber":
    case "managerPhoneNumber":
      return "blur_signUp_phone_number";
    case "password":
      return "blur_signUp_password";
    case "re_password":
      return "blur_signUp_password_confirm";
    case "businessLicenseNumber":
      return "blur_signUp_business_license_number";
    case "companyName":
      return "blur_signUp_company_name";
    case "managerName":
    default:
      return "blur_signUp_name";
  }
};
